import React from 'react';
import Slider from '../../components/slider/Slider';
import './Home.css';
import festivalImage from '../../assets/highlight/dashain.jpg';
import momoImage from '../../assets/highlight/momo.jpeg';
import stupaImage from '../../assets/highlight/BoudhanathStupa.jpg';
import everest from '../../assets/highlight/everest.jpg';
function Home() {
  return (
    <div>
      <Slider />

      <section className="section info-grid">
        <div className="about-card">
          <h2 className="section-heading">About Us</h2>
          <p>
            Southeastern Louisiana University&#39;s Nepalese Student Association (NSAS) is a
            student-run organization that promotes Nepalese culture, language, literature, and arts
            through various events and activities.
          </p>
          <p>
            NSAS hosts cultural programs, festivals, and social events while providing support and
            fostering friendships among students at SLU.
          </p>
          <p>
            We welcome everyone to join us in celebrating Nepalese traditions and building lifelong
            connections!
          </p>
        </div>

        <div className="social-card">
          <h2 className="section-heading">Follow Our Journey</h2>
          <p>Stay updated with our latest events on Instagram.</p>
          <iframe
            src="https://www.instagram.com/nsas.slu/embed/"
            title="Instagram Feed"
            width="100%"
            height="400px"
            className="social-iframe"></iframe>
        </div>
      </section>

      <section className="section highlights-section">
        <h2 className="section-heading">Cultural Highlights</h2>
        <div className="highlight-grid">
          <div className="highlight-card">
            <img src={everest} alt="Mt. Everest (Sagarmatha)" />
            <h4>Mt. Everest (Sagarmatha)</h4>
            <p>
              The world&apos;s tallest peak and a source of national pride, Sagarmatha stands as a
              symbol of strength and aspiration.
            </p>
          </div>
          <div className="highlight-card">
            <img src={stupaImage} alt="Boudhanath Stupa" />
            <h4>Boudhanath</h4>
            <p>
              One of the largest stupas in the world, symbolizing peace, spirituality, and cultural
              harmony.
            </p>
          </div>
          <div className="highlight-card">
            <img src={festivalImage} alt="Dashain Festival" />
            <h4>Dashain Festival</h4>
            <p>
              Nepal&apos;s biggest festival celebrating the triumph of good over evil with tika,
              jamara, and community gatherings.
            </p>
          </div>
          <div className="highlight-card">
            <img src={momoImage} alt="Nepali Momo" />
            <h4>Momo</h4>
            <p>
              Delicious Nepalese dumplings — a flavorful favorite for students and families alike.
            </p>
          </div>
        </div>
      </section>

      <section className="section map-section">
        <h2 className="section-heading">Our Location</h2>
        <div className="map-container">
          <iframe
            title="University Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.053867329164!2d-90.4710715!3d30.5178932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x862722985b04e61d%3A0xd65f00282c35660!2sSoutheastern%20Louisiana%20University!5e0!3m2!1sen!2sus!4v1652361250325!5m2!1sen!2sus"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"></iframe>
        </div>
      </section>
    </div>
  );
}

export default Home;
